export default __webpack_public_path__ + "static/media/Archpriest's Straps of the Nine Springs.a48140ee.jpg";